export default __webpack_public_path__ + "static/media/Robbins.b0ca0fb1.jfif";